@let checkInDate = data.checkInDate | date: 'MMM d';
@let checkoutDate = data.checkoutDate | date: 'MMM d';

<ds-border-wrapper>
  <div class="w-100">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex g-6 align-items-center w-100 noscroll">
        <img src="assets/icons/holiday_village.svg" alt="hotel" height="32" width="32" />
        <div class="d-flex flex-column g-1 w-100 noscroll">
          <div>
            <p data-id="booking-hotel-name" class="booking-hotel-card-title bold text-ellipsis">
              {{ data.name }}
            </p>
          </div>
          <div class="d-flex g-2 align-items-center">
            <p data-id="booking-hotel-city">{{ data.city }}</p>
            <ds-dot-separator />
            <div class="d-flex align-items-center">
              <p data-id="checkin-date">{{ checkInDate }}</p>
              -
              <p data-id="checkout-date">{{ checkoutDate }}</p>
            </div>
            <ds-dot-separator />
            <p data-id="booking-hotel-guests">
              {{ data.guestCount }} guest{{ data.guestCount !== 1 ? 's' : '' }}
            </p>
          </div>
        </div>
      </div>
      @if (isClickable) {
        <img src="assets/icons/booking_arrow.svg" alt="arrow" />
      }
    </div>
  </div>
</ds-border-wrapper>
